<template>
    <div class="inner-container" :class="{ 'min-container': !getTabs }">
        <div class="">
            <div class="page-header mb-0 ">
                <h1 class="w-100">
                    {{ $t("EDIT") }} {{ $t("CUSTOMER") }}
                </h1></div>
                

                <div class="content mt-0">
                    <div v-if="clientToConfig">
                    
                      
    <form @submit.prevent="clientupdate">
      <div class="center">
        <div class="row">
        <div class="col-lg-9 col-md-12 col-sm-12">
          <b-form-group label="Type" class="mt-2">
            <b-form-select
              v-model="v$.clientToConfig.type.$model"
              :options="options"
              :state="validateState('type')"
              aria-describedby="type-feedback"
              @change="v$.$reset()"
            ></b-form-select>
            <error-handle
              :list="v$.clientToConfig.type.$errors"
              id="type-feedback"
            ></error-handle>
            <div v-if="erreurlist.type" class="error-message">
              <ul v-if="Array.isArray(erreurlist.type)">
                <span v-for="(e, index) in erreurlist.type" :key="index">
                  {{ e }}
                </span>
              </ul>
              <span v-else>{{ erreurlist.type }}</span>
            </div>
          </b-form-group>
        </div>

      </div>
        <div
          v-if="isProfessionel"
          style="width: 100%"
        >
          <div class="row">
            <div class="col-lg-4 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('Raison sociale') + '*'">
                <b-form-input
                  v-model="v$.clientToConfig.raison_sociale.$model"
                  oninput="this.value = this.value.toUpperCase()"
                  :state="validateState('raison_sociale')"
                  aria-describedby="raison_sociale-feedback"
                ></b-form-input>
                <error-handle
                  :list="v$.clientToConfig.raison_sociale.$errors"
                  id="raison_sociale-feedback"
                ></error-handle>
                <div v-if="erreurlist.raison_sociale" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.raison_sociale)">
                    <span
                      v-for="(e, index) in erreurlist.raison_sociale"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.raison_sociale }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-4 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('Nom de commercial')">
                <b-form-input
                  v-model="clientToConfig.nom_commercial"
                  oninput="this.value = this.value.toUpperCase()"
                ></b-form-input>
                <div v-if="erreurlist.nom_commercial" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.nom_commercial)">
                    <span
                      v-for="(e, index) in erreurlist.nom_commercial"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.nom_commercial }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-4 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('SIRET') + '*'">
                <b-form-input
                  v-model="v$.clientToConfig.siret.$model"
                  :state="validateState('siret')"
                  aria-describedby="siret-feedback"
                ></b-form-input>
                <error-handle
                  :list="v$.clientToConfig.siret.$errors"
                  id="siret-feedback"
                ></error-handle>
                <div v-if="erreurlist.siret" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.siret)">
                    <span
                      v-for="(e, index) in erreurlist.siret"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.siret }}</span>
                </div>
              </b-form-group>
            </div>
          </div>
          <h5 class="titresociete mt-3">{{ $t("Signataire ") }}</h5>
          <div class="row">
            <div class="col-lg-6 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('Civilite')">
                <b-form-select
                  v-model="clientToConfig.civilite"
                  :options="optionsCivilite"
                ></b-form-select>
                <div v-if="erreurlist.civilite" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.civilite)">
                    <span
                      v-for="(e, index) in erreurlist.civilite"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.civilite }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-4 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('NAME') + '*'">
                <b-form-input
                  v-model="v$.clientToConfig.nom.$model"
                  oninput="this.value = this.value.toUpperCase()"
                  :state="validateState('nom')"
                  aria-describedby="nom-pro-feedback"
                  @input="updateSignataireNom"
                ></b-form-input>
                <error-handle
                  :list="v$.clientToConfig.nom.$errors"
                  id="nom-pro-feedback"
                ></error-handle>
                <div v-if="erreurlist.signataire_nom" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.signataire_nom)">
                    <span
                      v-for="(e, index) in erreurlist.signataire_nom"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.signataire_nom }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-4 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('SURNAME') + '*'">
                <b-form-input
                  v-model="v$.clientToConfig.prenom.$model"
                  oninput="this.value = this.value.toUpperCase()"
                  :state="validateState('prenom')"
                  aria-describedby="prenom-pro-feedback"
                  @input="updateSignatairePrenom"
                ></b-form-input>
                <error-handle
                  :list="v$.clientToConfig.prenom.$errors"
                  id="prenom-pro-feedback"
                ></error-handle>
                <div v-if="erreurlist.signataire_prenom" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.signataire_prenom)">
                    <span
                      v-for="(e, index) in erreurlist.signataire_prenom"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.signataire_prenom }}</span>
                </div>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('Fonction')">
                <b-form-input
                  v-model="clientToConfig.poste"
                  oninput="this.value = this.value.toUpperCase()"
                ></b-form-input>
                <div v-if="erreurlist.fonction" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.fonction)">
                    <span
                      v-for="(e, index) in erreurlist.fonction"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.fonction }}</span>
                </div>
              </b-form-group>
            </div>
          </div>

          <h5 class="titresociete mt-3">{{ $t("ADDRESS") }}</h5>
          <div class="row">
            <div class="col-lg-6 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('STREET') + '*'">
                <b-form-input
                  v-model="v$.clientToConfig.rue.$model"
                  :state="validateState('rue')"
                  aria-describedby="rue-feedback"
                ></b-form-input>
                <error-handle
                  :list="v$.clientToConfig.rue.$errors"
                  id="rue-feedback"
                ></error-handle>
                <div v-if="erreurlist.rue" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.rue)">
                    <span
                      v-for="(e, index) in erreurlist.rue"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.rue }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-6 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t(' Complément d\'adresse')">
                <b-form-input
                  v-model="clientToConfig.complement_adresse"
                ></b-form-input>
                <div v-if="erreurlist.complement_adresse" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.complement_adresse)">
                    <span
                      v-for="(e, index) in erreurlist.complement_adresse"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.complement_adresse }}</span>
                </div>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('POSTAL_CODE') + '*'">
                <b-form-input
                  v-model="v$.clientToConfig.cp.$model"
                  :state="validateState('cp')"
                  aria-describedby="cp-feedback"
                ></b-form-input>
                <error-handle
                  :list="v$.clientToConfig.cp.$errors"
                  id="cp-feedback"
                ></error-handle>
                <div v-if="erreurlist.cp" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.cp)">
                    <span
                      v-for="(e, index) in erreurlist.cp"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.cp }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-4 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('CITY') + '*'">
                <b-form-input
                  v-model="v$.clientToConfig.ville.$model"
                  :state="validateState('ville')"
                  aria-describedby="ville-feedback"
                ></b-form-input>
                <error-handle
                  :list="v$.clientToConfig.ville.$errors"
                  id="ville-feedback"
                ></error-handle>
                <div v-if="erreurlist.ville" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.ville)">
                    <span
                      v-for="(e, index) in erreurlist.ville"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.ville }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-4 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('COUNTRY') + ''">
                <multiselect
                  v-model="clientToConfig.pays"
                  :searchable="true"
                  :close-on-select="true"
                  :multiple="false"
                  :options="getAllcountries || getPays"
                  label="name"
                  track-by="id"
                >
                  <template slot="noResult">
                    {{ $t("NO_DATA_FOUND") }}
                  </template>
                </multiselect>
                <div v-if="erreurlist.pays" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.pays)">
                    <span v-for="(e, index) in erreurlist.pays" :key="index">
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.pays }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-4 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('Role') + '*'">
                <b-form-select
                  v-model="v$.clientToConfig.type_occupation.$model"
                  :options="optionsTypeOccupation"
                  text-field="text"
                  value-field="value"
                  :state="validateState('type_occupation')"
                  aria-describedby="type_occupation-pro-feedback"
                >
                  <template #first>
                    <b-form-select-option :value="null" disabled
                      >-- {{ $t("Role") }} --</b-form-select-option
                    >
                  </template>
                </b-form-select>
                <error-handle
                  :list="v$.clientToConfig.type_occupation.$errors"
                  id="type_occupation-pro-feedback"
                ></error-handle>
                <div v-if="erreurlist.type_occupation" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.type_occupation)">
                    <span
                      v-for="(e, index) in erreurlist.type_occupation"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.type_occupation }}</span>
                </div>
              </b-form-group>
            </div>
          </div>
          <h5 class="titresociete mt-3">{{ $t("CONTACT") }}</h5>
          <div class="row">
            <div class="col-lg-4 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('EMAIL') + '*'">
                <b-form-input
                  v-model="v$.clientToConfig.email.$model"
                  type="email"
                  :state="validateState('email')"
                  aria-describedby="email-pro-feedback"
                ></b-form-input>
                <error-handle
                  :list="v$.clientToConfig.email.$errors"
                  id="email-pro-feedback"
                ></error-handle>
                <div v-if="erreurlist.email" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.email)">
                    <span
                      v-for="(e, index) in erreurlist.email"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.email }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-4 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('Téléphone portable') + '**'">
                <template>
                  <phone :tel="clientToConfig.tel_mobile_pro || clientToConfig.phone" @phoneNumber="formatMobileNumberPro($event)"></phone>
                </template>
                <error-handle
                  :list="v$.clientToConfig.tel_mobile_pro.phone_number.$errors"
                  id="tel_mobile_pro-feedback"
                ></error-handle>
                <div v-if="erreurlist.tel_mobile_pro" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.tel_mobile_pro)">
                    <span
                      v-for="(e, index) in erreurlist.tel_mobile_pro"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.tel_mobile_pro }}</span>
                </div>
                <div
                  v-if="
                    clientToConfig.tel_mobile_pro && clientToConfig.tel_mobile_pro.phone_number && resultValidMobilePro == false
                  "
                  class="error-message"
                >
                  {{ $t("ERROR_PHONE") }}
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-4 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('Téléphone fixe') + '**'">
                <template>
                  <phone :tel="clientToConfig.tel_fixe_pro || clientToConfig.company_phone" @phoneNumber="formatFixedNumberPro($event)"></phone>
                </template>
                <error-handle
                  :list="v$.clientToConfig.tel_fixe_pro.phone_number.$errors"
                  id="tel_fixe_pro-feedback"
                ></error-handle>
                <div v-if="erreurlist.tel_fixe_pro" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.tel_fixe_pro)">
                    <span
                      v-for="(e, index) in erreurlist.tel_fixe_pro"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.tel_fixe_pro }}</span>
                </div>
                <div
                  v-if="
                    clientToConfig.tel_fixe_pro && clientToConfig.tel_fixe_pro.phone_number && resultValidFixePro == false
                  "
                  class="error-message"
                >
                  {{ $t("ERROR_PHONE") }}
                </div>
              </b-form-group>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-lg-4 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('ZONE') + '*'">
                <b-form-select
                  v-model="v$.clientToConfig.zone.$model"
                  :options="optionsZone"
                  text-field="text"
                  value-field="value"
                  :state="validateState('zone')"
                  aria-describedby="zone-pro-feedback"
                >
                  <template #first>
                    <b-form-select-option :value="null" disabled
                      >-- {{ $t("ZONE") }} --</b-form-select-option
                    >
                  </template>
                </b-form-select>
                <error-handle
                  :list="v$.clientToConfig.zone.$errors"
                  id="zone-pro-feedback"
                ></error-handle>
                <div v-if="erreurlist.zone" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.zone)">
                    <span
                      v-for="(e, index) in erreurlist.zone"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.zone }}</span>
                </div>
              </b-form-group>
            </div>
          </div>
          <h5 class="titresociete">{{ $t("COMPANY_BANK") }}</h5>
          <div class="row mt-2">
            <div class="col-md-6 col-lg-6 col-sm-12 py-0">
              <b-form-group :label="$t('ACCOUNT_OWNER')">
                <b-form-input
                  v-model="v$.clientToConfig.titulaire_compte.$model"
                  :state="validateState('titulaire_compte')"
                  aria-describedby="titulaire_compte-feedback"
                ></b-form-input>
                <error-handle
                  :list="v$.clientToConfig.titulaire_compte.$errors"
                  id="titulaire_compte-feedback"
                ></error-handle>
                <div
                  v-if="erreurlist.titulaire_compte"
                  class="error-message"
                >
                  <ul v-if="Array.isArray(erreurlist.titulaire_compte)">
                    <span
                      v-for="(e, index) in erreurlist.titulaire_compte"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.titulaire_compte }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-md-6 col-lg-6 col-sm-12 py-0">
              <b-form-group label="IBAN" label-for="IBAN">
                <b-form-input
                  v-model="v$.clientToConfig.IBAN.$model"
                  :state="validateState('IBAN')"
                  aria-describedby="IBAN-feedback"
                  oninput="this.value = this.value.toUpperCase()"
                ></b-form-input>
                <error-handle
                  :list="v$.clientToConfig.IBAN.$errors"
                  id="IBAN-feedback"
                ></error-handle>
                <div v-if="erreurlist.IBAN" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.IBAN)">
                    <span
                      v-for="(e, index) in erreurlist.IBAN"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.IBAN }}</span>
                </div>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4 col-md-12 col-sm-12">
              <b-form-group
                :label="$t('forme_juridique')"
                label-for="forme_juridique"
              >
                <b-form-input
                  v-model="v$.clientToConfig.forme_juridique.$model"
                  :state="validateState('forme_juridique')"
                  aria-describedby="forme_juridique-feedback"
                ></b-form-input>
                <error-handle
                  :list="v$.clientToConfig.forme_juridique.$errors"
                  id="forme_juridique-feedback"
                ></error-handle>
                <div
                  v-if="erreurlist.forme_juridique"
                  class="error-message"
                >
                  <ul v-if="Array.isArray(erreurlist.forme_juridique)">
                    <span
                      v-for="(e, index) in erreurlist.forme_juridique"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.forme_juridique }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-4 col-md-12 col-sm-12">
              <b-form-group :label="$t('ape')" label-for="ape">
                <b-form-input
                  v-model="v$.clientToConfig.ape.$model"
                  :state="validateState('ape')"
                  aria-describedby="ape-feedback"
                ></b-form-input>
                <error-handle
                  :list="v$.clientToConfig.ape.$errors"
                  id="ape-feedback"
                ></error-handle>
                <div v-if="erreurlist.ape" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.ape)">
                    <span
                      v-for="(e, index) in erreurlist.ape"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.ape }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-4 col-md-12 col-sm-12">
              <b-form-group :label="$t('naf')" label-for="naf">
                <b-form-input
                  v-model="v$.clientToConfig.naf.$model"
                  :state="validateState('naf')"
                  aria-describedby="naf-feedback"
                ></b-form-input>
                <error-handle
                  :list="v$.clientToConfig.naf.$errors"
                  id="ape-feedback"
                ></error-handle>
                <div v-if="erreurlist.naf" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.naf)">
                    <span
                      v-for="(e, index) in erreurlist.naf"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.naf }}</span>
                </div>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 col-lg-6 col-sm-12 py-0">
              <b-form-group label="SWIFT_BIC" label-for="SWIFT_BIC">
                <b-form-input
                  v-model="v$.clientToConfig.SWIFT_BIC.$model"
                  :state="validateState('SWIFT_BIC')"
                  aria-describedby="SWIFT_BIC-feedback"
                  oninput="this.value = this.value.toUpperCase()"
                ></b-form-input>
                <error-handle
                  :list="v$.clientToConfig.SWIFT_BIC.$errors"
                  id="SWIFT_BIC-feedback"
                ></error-handle>
                <div v-if="erreurlist.SWIFT_BIC" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.SWIFT_BIC)">
                    <span
                      v-for="(e, index) in erreurlist.SWIFT_BIC"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.SWIFT_BIC }}</span>
                </div>
              </b-form-group>
            </div>
          </div>

          <hr />

          <b-form-group
            :label="$t('COMMENTAIRE')"
            label-for="commentaire"
          >
            <b-form-textarea
              v-model="clientToConfig.commentaire"
              rows="3"
              max-rows="6"
            ></b-form-textarea>
            <div v-if="erreurlist.commentaire" class="error-message">
              <ul v-if="Array.isArray(erreurlist.commentaire)">
                <span
                  v-for="(e, index) in erreurlist.commentaire"
                  :key="index"
                >
                  {{ e }}
                </span>
              </ul>
              <span v-else>{{ erreurlist.commentaire }}</span>
            </div>
          </b-form-group>
        </div>

        <div
          v-if="!isProfessionel"
          style="width: 100%"
        >
          <div class="row">
            <div class="col-lg-4 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('Civilite') + ' 1*'">
                <b-form-select
                  v-model="v$.clientToConfig.civilite_1.$model"
                  :options="optionsCivilite"
                  :state="validateState('civilite_1')"
                  aria-describedby="civilite_1-feedback"
                ></b-form-select>
                <error-handle
                  :list="v$.clientToConfig.civilite_1.$errors"
                  id="civilite_1-feedback"
                ></error-handle>
                <div v-if="erreurlist.civilite_1" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.civilite_1)">
                    <span
                      v-for="(e, index) in erreurlist.civilite_1"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.civilite_1 }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-4 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('NAME') + '*'">
                <b-form-input
                  v-model="v$.clientToConfig.nom.$model"
                  oninput="this.value = this.value.toUpperCase()"
                  :state="validateState('nom')"
                  aria-describedby="nom-feedback"
                ></b-form-input>
                <error-handle
                  :list="v$.clientToConfig.nom.$errors"
                  id="nom-feedback"
                ></error-handle>
                <div v-if="erreurlist.nom" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.nom)">
                    <span
                      v-for="(e, index) in erreurlist.nom"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.nom }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-4 col-md-12 col-sm-12 py-0">
              <b-form-group
                :label="$t('SURNAME') + '*'"
                label-for="lastname"
              >
                <b-form-input
                  v-model="v$.clientToConfig.prenom.$model"
                  oninput="this.value = this.value.toUpperCase()"
                  :state="validateState('prenom')"
                  aria-describedby="prenom-feedback"
                ></b-form-input>
                <error-handle
                  :list="v$.clientToConfig.prenom.$errors"
                  id="prenom-feedback"
                ></error-handle>
                <div v-if="erreurlist.prenom" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.prenom)">
                    <span
                      v-for="(e, index) in erreurlist.prenom"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.prenom }}</span>
                </div>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('Téléphone portable') + '**'" label-for="telephone">
                <template>
                  <phone :tel="clientToConfig.tel_mobile || clientToConfig.phone || clientToConfig.tel" @phoneNumber="formatNumber($event)"></phone>
                </template>
                <error-handle
                  :list="v$.clientToConfig.tel_mobile.phone_number.$errors"
                  id="tel_mobile-feedback"
                ></error-handle>
                <div v-if="erreurlist.tel_mobile" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.tel_mobile)">
                    <span
                      v-for="(e, index) in erreurlist.tel_mobile"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.tel_mobile }}</span>
                </div>
                <div
                  v-if="
                    clientToConfig.tel_mobile && clientToConfig.tel_mobile.phone_number && resultValid == false
                  "
                  class="error-message"
                >
                  {{ $t("ERROR_PHONE") }}
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-6 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('Téléphone fixe') + '**'" label-for="telephone-fixe">
                <template>
                  <phone :tel="clientToConfig.tel_fixe" @phoneNumber="formatNumberFixe($event)"></phone>
                </template>
                <error-handle
                  :list="v$.clientToConfig.tel_fixe.phone_number.$errors"
                  id="tel_fixe-feedback"
                ></error-handle>
                <div v-if="erreurlist.tel_fixe" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.tel_fixe)">
                    <span
                      v-for="(e, index) in erreurlist.tel_fixe"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.tel_fixe }}</span>
                </div>
                <div
                  v-if="
                    clientToConfig.tel_fixe && clientToConfig.tel_fixe.phone_number && resultValidFixe == false
                  "
                  class="error-message"
                >
                  {{ $t("ERROR_PHONE") }}
                </div>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('Fonction')">
                <b-form-input
                  v-model="clientToConfig.fonction"
                  oninput="this.value = this.value.toUpperCase()"
                ></b-form-input>
                <div v-if="erreurlist.fonction" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.fonction)">
                    <span
                      v-for="(e, index) in erreurlist.fonction"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.fonction }}</span>
                </div>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('Civilite') + ' 2'">
                <b-form-select
                  v-model="clientToConfig.civilite_2"
                  :options="optionsCivilite"
                ></b-form-select>
                <div v-if="erreurlist.civilite_2" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.civilite_2)">
                    <span
                      v-for="(e, index) in erreurlist.civilite_2"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.civilite_2 }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-4 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('NAME') + ' 2'">
                <b-form-input
                  v-model="clientToConfig.nom_2"
                  oninput="this.value = this.value.toUpperCase()"
                ></b-form-input>
                <div v-if="erreurlist.nom_2" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.nom_2)">
                    <span
                      v-for="(e, index) in erreurlist.nom_2"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.nom_2 }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-4 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('SURNAME') + ' 2'">
                <b-form-input
                  v-model="clientToConfig.prenom_2"
                  oninput="this.value = this.value.toUpperCase()"
                ></b-form-input>
                <div v-if="erreurlist.prenom_2" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.prenom_2)">
                    <span
                      v-for="(e, index) in erreurlist.prenom_2"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.prenom_2 }}</span>
                </div>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('EMAIL') + '*'" label-for="email">
                <b-form-input
                  v-model="v$.clientToConfig.email.$model"
                  :state="validateState('email')"
                  aria-describedby="email-feedback"
                  type="email"
                ></b-form-input>
                <error-handle
                  :list="v$.clientToConfig.email.$errors"
                  id="email-feedback"
                ></error-handle>
                <div v-if="erreurlist.email" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.email)">
                    <span
                      v-for="(e, index) in erreurlist.email"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.email }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-6 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('EMAIL') + ' 2'" label-for="email2">
                <b-form-input
                  v-model="clientToConfig.email_2"
                  type="email"
                ></b-form-input>
                <div v-if="erreurlist.email_2" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.email_2)">
                    <span
                      v-for="(e, index) in erreurlist.email_2"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.email_2 }}</span>
                </div>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('STREET') + '*'" label-for="rue">
                <b-form-input
                  v-model="v$.clientToConfig.rue.$model"
                  :state="validateState('rue')"
                  aria-describedby="rue-feedback"
                ></b-form-input>
                <error-handle
                  :list="v$.clientToConfig.rue.$errors"
                  id="rue-feedback"
                ></error-handle>
                <div v-if="erreurlist.rue" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.rue)">
                    <span
                      v-for="(e, index) in erreurlist.rue"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.rue }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-6 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t(' Complément d\'adresse')" label-for="complement-adresse">
                <b-form-input
                  v-model="clientToConfig.complement_adresse"
                ></b-form-input>
                <div v-if="erreurlist.complement_adresse" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.complement_adresse)">
                    <span
                      v-for="(e, index) in erreurlist.complement_adresse"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.complement_adresse }}</span>
                </div>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4 col-md-12 col-sm-12 py-0">
              <b-form-group
                :label="$t('POSTAL_CODE') + '*'"
                label-for="cp"
              >
                <b-form-input
                  v-model="v$.clientToConfig.cp.$model"
                  :state="validateState('cp')"
                  aria-describedby="cp-feedback"
                ></b-form-input>
                <error-handle
                  :list="v$.clientToConfig.cp.$errors"
                  id="cp-feedback"
                ></error-handle>
                <div v-if="erreurlist.cp" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.cp)">
                    <span
                      v-for="(e, index) in erreurlist.cp"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.cp }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-4 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('CITY') + '*'" label-for="ville">
                <b-form-input
                  v-model="v$.clientToConfig.ville.$model"
                  :state="validateState('ville')"
                  aria-describedby="ville-feedback"
                ></b-form-input>
                <error-handle
                  :list="v$.clientToConfig.ville.$errors"
                  id="ville-feedback"
                ></error-handle>
                <div v-if="erreurlist.ville" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.ville)">
                    <span
                      v-for="(e, index) in erreurlist.ville"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.ville }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-4 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('COUNTRY') + ''">
                <multiselect
                  v-model="clientToConfig.pays"
                  :searchable="true"
                  :close-on-select="true"
                  :multiple="false"
                  :options="getPays"
                  label="name"
                  track-by="id"
                >
                  <template slot="noResult">
                    {{ $t("NO_DATA_FOUND") }}
                  </template>
                </multiselect>
                <div v-if="erreurlist.pays" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.pays)">
                    <span
                      v-for="(e, index) in erreurlist.pays"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.pays }}</span>
                </div>
                <div
                  v-if="v$.clientToConfig.pays.$error"
                  class="error-message"
                >
                  {{ $t("REQUIRED_FIELD") }}
                </div>
              </b-form-group>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-lg-4 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('ZONE') + '*'">
                <b-form-select
                  v-model="v$.clientToConfig.zone.$model"
                  :options="optionsZone"
                  text-field="text"
                  value-field="value"
                  :state="validateState('zone')"
                  aria-describedby="zone-feedback"
                >
                  <template #first>
                    <b-form-select-option :value="null" disabled
                      >-- {{ $t("ZONE") }} --</b-form-select-option
                    >
                  </template>
                </b-form-select>
                <error-handle
                  :list="v$.clientToConfig.zone.$errors"
                  id="zone-feedback"
                ></error-handle>
                <div v-if="erreurlist.zone" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.zone)">
                    <span
                      v-for="(e, index) in erreurlist.zone"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.zone }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-4 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('PRECARITE')">
                <b-form-select
                  v-model="clientToConfig.precarite"
                  :options="optionsprecarite"
                  text-field="text"
                  value-field="value"
                >
                  <template #first>
                    <b-form-select-option :value="null" disabled
                      >-- {{ $t("PRECARITE") }} --</b-form-select-option
                    >
                  </template>
                </b-form-select>
                <div v-if="erreurlist.precarite" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.precarite)">
                    <span
                      v-for="(e, index) in erreurlist.precarite"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.precarite }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-4 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('Role') + '*'">
                <b-form-select
                  v-model="v$.clientToConfig.type_occupation.$model"
                  :options="optionsTypeOccupation"
                  text-field="text"
                  value-field="value"
                  :state="validateState('type_occupation')"
                  aria-describedby="type_occupation-feedback"
                >
                  <template #first>
                    <b-form-select-option :value="null" disabled
                      >-- {{ $t("Role") }} --</b-form-select-option
                    >
                  </template>
                </b-form-select>
                <error-handle
                  :list="v$.clientToConfig.type_occupation.$errors"
                  id="type_occupation-feedback"
                ></error-handle>
                <div v-if="erreurlist.type_occupation" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.type_occupation)">
                    <span
                      v-for="(e, index) in erreurlist.type_occupation"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.type_occupation }}</span>
                </div>
              </b-form-group>
            </div>
          </div>
        </div>
        <div v-if="!isProfessionel">
          <h5>{{ $t("Informations fiscal") }}</h5>
          
          <MenagesStep
            :menageParentData="menageData"
            @update-menage="handleMenageUpdate"
          />

          <div class="row my-3">
            <div class="col-lg-4 col-md-12 col-sm-12 pl-2 py-0">
              <b-form-group :label="$t('Foyer fiscaux')">
                <b-form-input
                  v-model="menageData.foyer_fiscal"
                ></b-form-input>
                <div v-if="erreurlist.foyer_fiscal" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.foyer_fiscal)">
                    <span
                      v-for="(e, index) in erreurlist.foyer_fiscal"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.foyer_fiscal }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-4 col-md-12 col-sm-12 pl-2 py-0">
              <b-form-group :label="$t('Année des revenus')">
                <b-form-input
                  v-model="menageData.annee_revenus"
                  type="number"
                  min="1900"
                  max="2100"
                ></b-form-input>
                <div v-if="erreurlist.annee_revenus" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.annee_revenus)">
                    <span
                      v-for="(e, index) in erreurlist.annee_revenus"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.annee_revenus }}</span>
                </div>
              </b-form-group>
            </div>
            <div class="col-lg-4 col-md-12 col-sm-12 pl-2 py-0">
              <b-form-group :label="$t('Année d’imposition')">
                <b-form-input
                  v-model="menageData.annee_imposition"
                  type="number"
                  min="1900"
                  max="2100"
                ></b-form-input>
                <div v-if="erreurlist.annee_imposition" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.annee_imposition)">
                    <span
                      v-for="(e, index) in erreurlist.annee_imposition"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.annee_imposition }}</span>
                </div>
              </b-form-group>
            </div>
          </div>
        </div>
      <b-form-group :label="$t('COMPANY_ID')" v-if="isSuperAdmin">
        <multiselect
          v-model="clientToConfig.entreprise"
          :searchable="true"
          :close-on-select="true"
          :multiple="false"
          :options="getAllentreprises"
          label="lib"
          track-by="id"
          class="form-input custom-placeholder custom-input"
        >
          <template slot="noResult">
            {{ $t("NO_DATA_FOUND") }}
          </template>
        </multiselect>
        <div
          v-if="v$.clientToConfig.entreprise.$error"
          class="error-message"
        >
          {{ $t("REQUIRED_FIELD") }}
        </div>
        <div v-if="erreurlist.entreprise" class="error-message">
          <ul v-if="Array.isArray(erreurlist.entreprise)">
            <span
              v-for="(e, index) in erreurlist.entreprise"
              :key="index"
            >
              {{ e }}
            </span>
          </ul>
          <span v-else>{{ erreurlist.entreprise }}</span>
        </div>
      </b-form-group>
      </div>
    </form> 
    <div>
      <b-alert variant="warning" show v-if="errorU">
        {{ errorU }}
      </b-alert>
      <div class="double my-4 d-flex justify-content-end">
        <b-button variant="danger" @click="resetModal()" class="mr-2">
          <div class="block-spinner">
            {{ $t("CANCEL") }}
          </div>
        </b-button>
        <b-button
          variant="success"
          @click="clientupdate"
          v-if="
            isSuperAdmin || isentrepriseAdmin || isAssistant || isCommercial
          "
        >
          <div class="block-spinner">
            {{ $t("CONFIRM") }}
            <div v-if="getclientLoading" class="loading ml-2">
              <div class="spinner-border" role="status"></div>
            </div>
          </div>
        </b-button>
      </div>
    </div>
                    </div>
                </div>
            </div>
        </div>
</template>
<script>
    import "vue-phone-number-input/dist/vue-phone-number-input.css";
    import { domains } from "@/environment";
    import { mapActions, mapGetters } from "vuex";
    import { useVuelidate } from "@vuelidate/core";
    import {
      required,
      email,
      maxLength,
      minLength,
      requiredIf,
      alphaNum,
      numeric,
    } from "@vuelidate/validators";
    import errorHandle from "../ui/errorHandle.vue";
  import phone from "../ui/phone.vue";
  import MenagesStep from "../menages/MenagesStep.vue";
    export default {
        components: {
      errorHandle,
      phone,
      MenagesStep
    },  
    setup() {
      return { v$: useVuelidate({ $lazy: true, $autoDirty: true }) };
    },
    validations() {
    return {
      clientToConfig: {
        type: { required },
        // Champs obligatoires pour particulier
        // Champs obligatoires pour tous les types
        nom: {
          required,
          maxLength: maxLength(100),
        },
        prenom: {
          required,
          maxLength: maxLength(100),
        },
        email: {
          required,
          email,
          maxLength: maxLength(50),
        },
        rue: {
          required,
          maxLength: maxLength(100),
        },
        cp: {
          required,
          numeric,
          minLength: minLength(4),
          maxLength: maxLength(5),
        },
        ville: {
          required,
          maxLength: maxLength(100),
        },
        zone: {
          required,
        },
        type_occupation: {
          required,
        },
        // Validation téléphone : soit portable OU fixe (l'un des deux obligatoire pour particuliers seulement)
        tel_mobile: {
          phone_number: {
            requiredIf: requiredIf(() => {
              // Seulement pour les particuliers
              if (this.isProfessionel) return false;
              // Vérifier si tel_fixe n'est pas rempli
              const hasTelFixe = this.clientToConfig.tel_fixe && this.clientToConfig.tel_fixe.phone_number;
              return !hasTelFixe;
            }),
          },
        },
        tel_fixe: {
          phone_number: {
            requiredIf: requiredIf(() => {
              // Seulement pour les particuliers
              if (this.isProfessionel) return false;
              // Vérifier si tel_mobile n'est pas rempli
              const hasTelMobile = this.clientToConfig.tel_mobile && this.clientToConfig.tel_mobile.phone_number;
              return !hasTelMobile;
            }),
          },
        },
        // Champs optionnels
        civilite_1: {},
        pays: {},
        entreprise: { requiredIf: requiredIf(this.isSuperAdmin) },
        // Champs obligatoires pour professionnel
        raison_sociale: {
          requiredIf: requiredIf(() => this.isProfessionel),
          maxLength: maxLength(100),
        },
        siret: {
          requiredIf: requiredIf(() => this.isProfessionel),
        },
        signataire_nom: {
          maxLength: maxLength(100),
        },
        signataire_prenom: {
          maxLength: maxLength(100),
        },
        company: {
          maxLength: maxLength(100),
        },
        company_email: {
          email,
          maxLength: maxLength(50),
        },
        tel_mobile_pro: {
          phone_number: {
            requiredIf: requiredIf(() => {
              // Seulement pour les professionnels
              if (!this.isProfessionel) return false;
              // Vérifier si tel_fixe_pro n'est pas rempli
              const hasTelFixePro = this.clientToConfig.tel_fixe_pro && this.clientToConfig.tel_fixe_pro.phone_number;
              return !hasTelFixePro;
            }),
          },
        },
        tel_fixe_pro: {
          phone_number: {
            requiredIf: requiredIf(() => {
              // Seulement pour les professionnels
              if (!this.isProfessionel) return false;
              // Vérifier si tel_mobile_pro n'est pas rempli
              const hasTelMobilePro = this.clientToConfig.tel_mobile_pro && this.clientToConfig.tel_mobile_pro.phone_number;
              return !hasTelMobilePro;
            }),
          },
        },
        poste: {
          maxLength: maxLength(40),
        },
        SWIFT_BIC: {
          minLength: minLength(8),
          maxLength: maxLength(11),
          alphaNum,
        },
        IBAN: { maxLength: maxLength(34), alphaNum },
        titulaire_compte: { maxLength: maxLength(40) },
        forme_juridique: {},
        naf: {},
        ape: {},
      },
    };
  },
  
    data() {
    return {
      menageData:{},
      statuscheckbox: "Autre adresse",
      downloadUrl: domains.download,
      filetoupdate: {
        lib: null,
        description: null,
        categorie: null,
        client_id: null,
        file: null,
      },
      erreurlist: {
        nom: null,
        prenom: null,
        email: null,
        email_2: null,
        rue: null,
        complement_adresse: null,
        cp: null,
        ville: null,
        tel: null,
        tel_mobile: null,
        tel_fixe: null,
        type: null,
        entreprise: null,
        pays: null,
        SWIFT_BIC: null,
        // revenu_avis_imposition:null,
        IBAN: null,
        titulaire_compte: null,
        commentaire: null,
        forme_juridique:null,
        ape:null,
        naf:null,
        company: null,
        company_email: null,
        company_phone: null,
        zone: null,
        precarite: null,
        type_chauffage: null,
        type_logement: null,
        foyer_fiscal: null,
        annee_revenus: null,
        annee_imposition: null,
        civilite_1: null,
        civilite_2: null,
        nom_2: null,
        prenom_2: null,
      },
      optionsprecarite: [
        { value: "Modeste", text: this.$t("Modeste") },
          { value: "Intermédiaires", text: this.$t("Intermédiaires") },
          { value: "tres_modeste", text: this.$t("Tmodeste") },
          { value: "supérieurs", text: this.$t("Supérieurs") },
        ],
      optionsTypeOccupation: [
        { value: "Propriétaire", text: "Propriétaire" },
        { value: "locataire", text: "Locataire" },
        { value: "autre", text: "Autre" },
        { value: "Maître d'ouvrage", text: "Maître d'ouvrage" },
      ],
      vueTel: {
        preferredCountries: ["FR", "TN"],
        placeholder: "Enter your phone",
        mode: "auto",
        inputOptions: {
          showDialCode: true,
        },
        disabledFormatting: false,
        validCharactersOnly: true,
        wrapperClasses: "country-phone-input",
      },
      document: {
        lib: null,
        description: null,
        categorie: null,
        client_id: null,
        file: null,
      },
      search: "",
      clientToConfig: null,
      clientToConfigRef: null,
      clientToDelete: null,
      clientDetail: {
        type: null,
        email: null,
        tel: null,
        rue: null,
        ville: null,
      },
      clientDetailRef: null,
      page: 1,
      perPage: 10,
   
    optionsZone: [
        { value: "h1", text: "H1" },
        { value: "h2", text: "H2" },
        { value: "h3", text: "H3" },
      ],
      options: [
        { value: "type.particulier", text: this.$t("PARTICULAR") },
        { value: "type.professionnel", text: this.$t("PROFESSIONAL") },
        { value: "type.bailleur_sociale", text: "Bailleur sociale" },
        { value: "type.syndic_copropriete_professionnel", text: "Syndic copropriété professionnel" },
        { value: "type.entreprise", text: "Entreprise" },
        { value: "type.etablissement", text: "Établissement" },
        { value: "type.collectivite_territoriale_mairie", text: "Collectivité territoriale / Mairie" },
        { value: "type.organisation_professionnelle", text: "Organisation professionnelle" },
        { value: "type.syndic_copropriete_benevole", text: "Syndic copropriété bénévole" },
      ],
      optionsCivilite: [
        { value: "Monsieur", text: "Monsieur" },
        { value: "Madame", text: "Madame" },
      
      ],
      current_entreprise: {
        id: null,
      },
      filtre_type: null,
      currenttype: null,
      errorU: null,
      documents: null,
      infoClient: 0,
      loadingInfo: false,
      step: 1,
      resultValid: null,
      phoneValid: null,
      resultValidFixe: null,
      resultValidMobilePro: null,
      resultValidFixePro: null,
    };
  },
  async mounted() {
  const client_id = this.$route.params.id;
  
    const res = await this.client(client_id);
    this.clientToConfig = res.data;
    
    // Pour les clients professionnels, s'assurer que l'email est initialisé depuis l'API
    if (this.isProfessionel) {
      // Si email existe dans l'API, l'utiliser
      if (res.data.email) {
        this.clientToConfig.email = res.data.email;
      }
      // Si company_email existe mais pas email, utiliser company_email
      else if (res.data.company_email && !this.clientToConfig.email) {
        this.clientToConfig.email = res.data.company_email;
      }
      // Initialiser nom et prenom depuis signataire_nom et signataire_prenom
      if (res.data.signataire_nom && !this.clientToConfig.nom) {
        this.clientToConfig.nom = res.data.signataire_nom;
      }
      if (res.data.signataire_prenom && !this.clientToConfig.prenom) {
        this.clientToConfig.prenom = res.data.signataire_prenom;
      }
      console.log('=== EMAIL CLIENT PROFESSIONNEL ===', {
        email: this.clientToConfig.email,
        company_email: this.clientToConfig.company_email,
        apiEmail: res.data.email,
        apiCompanyEmail: res.data.company_email
      });
    }
    
    // Pour les particuliers, initialiser le champ fonction depuis poste si disponible
    if (!this.isProfessionel && res.data.poste && !this.clientToConfig.fonction) {
      this.clientToConfig.fonction = res.data.poste;
    }
   
    // Attendre que Vue mette à jour le DOM, puis formater les numéros de téléphone
    await this.$nextTick();
    this.formatPhoneNumbers();
    // Attendre encore un tick pour que les composants enfants reçoivent les données
    await this.$nextTick();
   
  this.pays('fr');
  this.all_countries({ page: this.page, perPage: 100000 });
  
  // Charger les entreprises si l'utilisateur est super-admin
  if (this.isSuperAdmin) {
    this.all_entreprises({ page: 1, per_page: 1000 });
  }
  
  this.menageData = this.initializeMenageData();
},
computed: {
    ...mapGetters([
      "getPays",
      "getdatafile",
      "getAllCategorie",
      "getAllclients",
      "getclientLoading",
      "getTotalRowclient",
      "getAllentreprises",
      "getentrepriseLoading",
      "getAllUsers",
      "getTabs",
      "getclient",
      "getOnlineUser",
      "getdevisLoading",
      "getTotalRowdevis",
      "getAlldevis",
      "getFactureLoading",
      "getfactureRows",
      "getAllFacture",
      "getagendaLoading",
      "getAgenda",
      "getdictionnaire",
      "getSelectedLang",
      "getPays",
      "getentreprise",
      "getErreur",
      "getAllcountries",
    ]),

    translations() {
      var trans = {
        countrySelectorLabel: "Choisir un pays",
        phoneNumberLabel: "Numéro de téléphone",
      };
      this.getdictionnaire.forEach((element) => {
        if (element.key == "countrySelectorLabel")
          trans.countrySelectorLabel = element.lib;
        if (element.key == "phoneNumberLabel")
          trans.phoneNumberLabel = element.lib;
      });

      return trans;
    },

    query() {
      return this.$route.query.entreprise;
    },

    isSuperAdmin() {
      return this.getOnlineUser.role == "user.super-admin";
    },
    isentrepriseAdmin() {
      return this.getOnlineUser.role == "user.entreprise-admin";
    },
    isCommercial() {
      return this.getOnlineUser.role == "user.commercial-entreprise";
    },
    isTechnicien() {
      return this.getOnlineUser.role == "user.technicien";
    },
    isAssistant() {
      return this.getOnlineUser.role == "user.assistant";
    },
    isCommercialBatigo() {
      return this.getOnlineUser.role == "user.commercial-batigo";
    },
    isProfessionel() {
      if (this.clientToConfig && this.clientToConfig.type) {
        const professionalTypes = [
          'type.professionnel',
          'type.bailleur_sociale',
          'type.syndic_copropriete_professionnel',
          'type.entreprise',
          'type.etablissement',
          'type.collectivite_territoriale_mairie',
          'type.organisation_professionnelle',
          'type.syndic_copropriete_benevole'
        ];
        return professionalTypes.includes(this.clientToConfig.type);
      }
      return false;
    },
    searchBarText() {
      return `${this.$t("CLIENT_SEARCH")} ( ${this.$t("NAME")}, ${this.$t(
        "SURNAME"
      )}, ${this.$t("EMAIL")} )`;
    },
  },

    methods: {
    ...mapActions([
      "editMenage",
      "all_countries",
      "all_users",
      "get_data_file",
      "allCategorie",
      "edit_client",
      "all_clients",
      "delete_client",
      "all_entreprises",
      "client",
      "add_to_datafile",
      "delete_from_datafile",
      "update_datafile",
      "devis",
      "factures",
      "all_rendezvous",
      "pays",
      "entreprise",
      "storeMenage"
    ]),
    // Fonction helper pour extraire le code pays depuis un numéro formaté
    extractCountryCodeFromFormattedPhone(formattedPhone) {
      if (!formattedPhone || typeof formattedPhone !== 'string') return null;
      
      // Mapping des codes pays courants (préfixes téléphoniques -> codes ISO)
      const countryCodeMap = {
        '1': 'US', // USA/Canada
        '33': 'FR', // France
        '216': 'TN', // Tunisie
        '212': 'MA', // Maroc
        '213': 'DZ', // Algérie
        '32': 'BE', // Belgique
        '41': 'CH', // Suisse
        '44': 'GB', // UK
        '49': 'DE', // Allemagne
        '34': 'ES', // Espagne
        '39': 'IT', // Italie
        '31': 'NL', // Pays-Bas
        '351': 'PT', // Portugal
        '352': 'LU', // Luxembourg
      };
      
      const trimmed = formattedPhone.trim();
      if (trimmed.startsWith('+')) {
        // Extraire le préfixe pays (1-4 chiffres après le +)
        const match = trimmed.match(/^\+(\d{1,4})/);
        if (match && match[1]) {
          const prefix = match[1];
          // Chercher dans le mapping
          if (countryCodeMap[prefix]) {
            return countryCodeMap[prefix];
          }
          // Si pas trouvé, essayer de deviner depuis les codes les plus courants
          // Pour +1, c'est US/CA
          if (prefix === '1') return 'US';
          // Pour +33, c'est FR
          if (prefix === '33') return 'FR';
        }
      }
      return null;
    },
    
    formatPhoneNumbers() {
      if (!this.clientToConfig) return;
      
      // Pour les clients particuliers
      if (this.clientToConfig.type === 'type.particulier') {
        // Téléphone mobile - utiliser tel_mobile existant, tel_mobile_phone_number, phone ou tel
        if (this.clientToConfig.tel_mobile_phone_number || this.clientToConfig.tel_mobile) {
          // Si tel_mobile existe déjà comme objet, vérifier qu'il a bien le code ISO
          if (this.clientToConfig.tel_mobile && typeof this.clientToConfig.tel_mobile === 'object' && this.clientToConfig.tel_mobile.phone_number) {
            // Si phone_iso_code n'est pas défini mais formated_phone existe, extraire le code
            if (!this.clientToConfig.tel_mobile.phone_iso_code && this.clientToConfig.tel_mobile.formated_phone) {
              const extractedCode = this.extractCountryCodeFromFormattedPhone(this.clientToConfig.tel_mobile.formated_phone);
              if (extractedCode) {
                this.$set(this.clientToConfig.tel_mobile, 'phone_iso_code', extractedCode);
                this.$set(this.clientToConfig.tel_mobile, 'iso_code', extractedCode);
              }
            }
          } else {
            // Formater tel_mobile depuis tel_mobile_phone_number ou tel_mobile
            const mobileNumber = this.clientToConfig.tel_mobile_phone_number || 
                               (typeof this.clientToConfig.tel_mobile === 'string' ? this.clientToConfig.tel_mobile : this.clientToConfig.tel_mobile?.phone_number);
            let mobileIsoCode = this.clientToConfig.tel_mobile_phone_iso_code || 
                              (typeof this.clientToConfig.tel_mobile === 'object' ? this.clientToConfig.tel_mobile?.phone_iso_code : null);
            
            // Si pas de code ISO, essayer de l'extraire depuis formated_phone si disponible
            if (!mobileIsoCode && this.clientToConfig.tel_mobile?.formated_phone) {
              mobileIsoCode = this.extractCountryCodeFromFormattedPhone(this.clientToConfig.tel_mobile.formated_phone);
            }
            
            mobileIsoCode = mobileIsoCode || 'FR';
            
            if (mobileNumber) {
              this.$set(this.clientToConfig, 'tel_mobile', {
                phone_number: mobileNumber,
                phone_iso_code: mobileIsoCode,
                iso_code: mobileIsoCode,
                formated_phone: this.clientToConfig.tel_mobile?.formated_phone || null,
              });
            }
          }
        } else if (this.clientToConfig.phone) {
          // Fallback sur phone
          let phoneNumber = this.clientToConfig.phone.phone_number;
          
          // Si phone_number n'existe pas, extraire depuis formated_phone
          if (!phoneNumber && this.clientToConfig.phone.formated_phone) {
            const formatted = this.clientToConfig.phone.formated_phone.trim();
            if (formatted.startsWith("+")) {
              // Extraire le numéro depuis formated_phone en retirant SEULEMENT le préfixe pays
              // Exemple: "+33745665533" -> "745665533" (retirer "+33")
              phoneNumber = formatted.replace(/^\+\d{1,4}/, '').trim();
              // Retirer tous les espaces restants
              phoneNumber = phoneNumber.replace(/\s+/g, '');
            } else {
              phoneNumber = formatted.replace(/\s+/g, '');
            }
          }
          
          // Fallback sur tel si nécessaire
          if (!phoneNumber) {
            phoneNumber = this.clientToConfig.tel;
          }
          
          // S'assurer que phoneNumber est une string et ne contient que des chiffres
          if (phoneNumber) {
            phoneNumber = phoneNumber.toString().replace(/[^\d]/g, '');
          }
          
          // Récupérer le code ISO depuis différentes sources possibles
          let isoCode = this.clientToConfig.phone.iso_code || 
                       (this.clientToConfig.phone.country_id && this.clientToConfig.phone.country_id.iso_code) ||
                       this.clientToConfig.phone.phone_iso_code;
          
          // Si pas de code ISO mais formated_phone existe, extraire depuis formated_phone
          if (!isoCode && this.clientToConfig.phone.formated_phone) {
            isoCode = this.extractCountryCodeFromFormattedPhone(this.clientToConfig.phone.formated_phone);
          }
          
          isoCode = isoCode || 'FR';
          
          const formatedPhone = this.clientToConfig.phone.formated_phone || null;
          
          this.$set(this.clientToConfig, 'tel_mobile', {
            phone_number: phoneNumber,
            phone_iso_code: isoCode,
            iso_code: isoCode,
            formated_phone: formatedPhone,
          });
        } else if (this.clientToConfig.tel) {
          // Fallback: utiliser tel directement si phone n'existe pas
          this.$set(this.clientToConfig, 'tel_mobile', {
            phone_number: this.clientToConfig.tel,
            phone_iso_code: 'FR',
            iso_code: 'FR',
            formated_phone: null,
          });
        }
        
        // Téléphone fixe
        if (this.clientToConfig.tel_fixe_phone_number || this.clientToConfig.tel_fixe) {
          const fixeNumber = this.clientToConfig.tel_fixe_phone_number || 
                           (typeof this.clientToConfig.tel_fixe === 'string' ? this.clientToConfig.tel_fixe : this.clientToConfig.tel_fixe?.phone_number);
          let fixeIsoCode = this.clientToConfig.tel_fixe_phone_iso_code || 
                          (typeof this.clientToConfig.tel_fixe === 'object' ? this.clientToConfig.tel_fixe?.phone_iso_code : null);
          
          // Si pas de code ISO mais formated_phone existe, extraire depuis formated_phone
          if (!fixeIsoCode && this.clientToConfig.tel_fixe?.formated_phone) {
            fixeIsoCode = this.extractCountryCodeFromFormattedPhone(this.clientToConfig.tel_fixe.formated_phone);
          }
          
          fixeIsoCode = fixeIsoCode || 'FR';
          
          if (fixeNumber) {
            this.$set(this.clientToConfig, 'tel_fixe', {
              phone_number: fixeNumber,
              phone_iso_code: fixeIsoCode,
              iso_code: fixeIsoCode,
              formated_phone: this.clientToConfig.tel_fixe?.formated_phone || null,
            });
          }
        }
      }
      
      // Pour les clients professionnels
      if (this.isProfessionel) {
        // Initialiser tel_mobile et tel_fixe comme objets vides pour éviter les erreurs de validation
        // (ces champs ne sont pas utilisés pour les professionnels, mais la validation peut les vérifier)
        if (!this.clientToConfig.tel_mobile) {
          this.$set(this.clientToConfig, 'tel_mobile', {
            phone_number: null,
            phone_iso_code: null,
          });
        }
        if (!this.clientToConfig.tel_fixe) {
          this.$set(this.clientToConfig, 'tel_fixe', {
            phone_number: null,
            phone_iso_code: null,
          });
        }
        
        // Téléphone mobile pro depuis phone
        if (this.clientToConfig.phone) {
          console.log('=== Initialisation tel_mobile_pro depuis phone ===');
          console.log('phone object:', this.clientToConfig.phone);
          
          // Utiliser phone_number directement s'il existe (c'est déjà le numéro sans préfixe)
          let phoneNumber = this.clientToConfig.phone.phone_number;
          
          // Si phone_number n'existe pas, extraire depuis formated_phone
          if (!phoneNumber && this.clientToConfig.phone.formated_phone) {
            const formatted = this.clientToConfig.phone.formated_phone.trim();
            console.log('Extraction depuis formated_phone:', formatted);
            if (formatted.startsWith("+")) {
              // Extraire le numéro depuis formated_phone en retirant SEULEMENT le préfixe pays
              // Exemple: "+21658749654" -> "58749654" (retirer "+216")
              phoneNumber = formatted.replace(/^\+\d{1,4}/, '').trim().replace(/\s+/g, '');
            } else {
              phoneNumber = formatted.replace(/\s+/g, '');
            }
          }
          
          if (!phoneNumber) {
            phoneNumber = this.clientToConfig.tel;
          }
          
          // Nettoyer le numéro (garder seulement les chiffres)
          if (phoneNumber) {
            phoneNumber = phoneNumber.toString().replace(/[^\d]/g, '');
          }
          
          console.log('phoneNumber nettoyé:', phoneNumber);
          
          // Récupérer le code ISO - PRIORITÉ à iso_code et country_id.iso_code
          let isoCode = this.clientToConfig.phone.iso_code || 
                       (this.clientToConfig.phone.country_id && this.clientToConfig.phone.country_id.iso_code) ||
                       this.clientToConfig.phone.phone_iso_code;
          
          console.log('isoCode depuis phone:', isoCode);
          console.log('phone.iso_code:', this.clientToConfig.phone.iso_code);
          console.log('phone.country_id:', this.clientToConfig.phone.country_id);
          console.log('phone.country_id.iso_code:', this.clientToConfig.phone.country_id?.iso_code);
          
          // Si pas de code ISO mais formated_phone existe, extraire depuis formated_phone
          if (!isoCode && this.clientToConfig.phone.formated_phone) {
            isoCode = this.extractCountryCodeFromFormattedPhone(this.clientToConfig.phone.formated_phone);
            console.log('isoCode extrait depuis formated_phone:', isoCode);
          }
          
          isoCode = isoCode || 'FR';
          const formatedPhone = this.clientToConfig.phone.formated_phone || null;
          
          console.log('isoCode final:', isoCode);
          console.log('formatedPhone:', formatedPhone);
          
          this.$set(this.clientToConfig, 'tel_mobile_pro', {
            phone_number: phoneNumber,
            phone_iso_code: isoCode,
            iso_code: isoCode,
            formated_phone: formatedPhone,
          });
          
          console.log('tel_mobile_pro initialisé:', this.clientToConfig.tel_mobile_pro);
        }
        
        // Téléphone fixe pro depuis company_phone
        if (this.clientToConfig.company_phone) {
          console.log('=== Initialisation tel_fixe_pro depuis company_phone ===');
          console.log('company_phone object:', this.clientToConfig.company_phone);
          
          // Utiliser phone_number directement s'il existe (c'est déjà le numéro sans préfixe)
          let companyPhoneNumber = this.clientToConfig.company_phone.phone_number;
          
          // Si phone_number n'existe pas, extraire depuis formated_phone
          if (!companyPhoneNumber && this.clientToConfig.company_phone.formated_phone) {
            const formatted = this.clientToConfig.company_phone.formated_phone.trim();
            console.log('Extraction depuis formated_phone:', formatted);
            if (formatted.startsWith("+")) {
              // Extraire le numéro depuis formated_phone en retirant SEULEMENT le préfixe pays
              // Exemple: "+21658749654" -> "58749654" (retirer "+216")
              companyPhoneNumber = formatted.replace(/^\+\d{1,4}/, '').trim().replace(/\s+/g, '');
            } else {
              companyPhoneNumber = formatted.replace(/\s+/g, '');
            }
          }
          
          // Nettoyer le numéro (garder seulement les chiffres)
          if (companyPhoneNumber) {
            companyPhoneNumber = companyPhoneNumber.toString().replace(/[^\d]/g, '');
          }
          
          console.log('companyPhoneNumber nettoyé:', companyPhoneNumber);
          
          // Récupérer le code ISO - PRIORITÉ à iso_code et country_id.iso_code
          let companyIsoCode = this.clientToConfig.company_phone.iso_code || 
                             (this.clientToConfig.company_phone.country_id && this.clientToConfig.company_phone.country_id.iso_code) ||
                             this.clientToConfig.company_phone.phone_iso_code;
          
          console.log('companyIsoCode depuis company_phone:', companyIsoCode);
          console.log('company_phone.iso_code:', this.clientToConfig.company_phone.iso_code);
          console.log('company_phone.country_id:', this.clientToConfig.company_phone.country_id);
          console.log('company_phone.country_id.iso_code:', this.clientToConfig.company_phone.country_id?.iso_code);
          
          // Si pas de code ISO mais formated_phone existe, extraire depuis formated_phone
          if (!companyIsoCode && this.clientToConfig.company_phone.formated_phone) {
            companyIsoCode = this.extractCountryCodeFromFormattedPhone(this.clientToConfig.company_phone.formated_phone);
            console.log('companyIsoCode extrait depuis formated_phone:', companyIsoCode);
          }
          
          companyIsoCode = companyIsoCode || 'FR';
          const companyFormatedPhone = this.clientToConfig.company_phone.formated_phone || null;
          
          console.log('companyIsoCode final:', companyIsoCode);
          console.log('companyFormatedPhone:', companyFormatedPhone);
          
          if (companyPhoneNumber) {
            this.$set(this.clientToConfig, 'tel_fixe_pro', {
              phone_number: companyPhoneNumber,
              phone_iso_code: companyIsoCode,
              iso_code: companyIsoCode,
              formated_phone: companyFormatedPhone,
            });
            
            console.log('tel_fixe_pro initialisé:', this.clientToConfig.tel_fixe_pro);
          }
        }
      }
    },
    initializeMenageData() {
      const menage = this.clientToConfig || {};
      return {
        revenu: menage.menage?.revenu || null,
        personnes: menage.menage?.personnes || null,
        commune: menage.menage?.commune || "",
        foyer_fiscal: menage.foyer_fiscal || menage.menage?.foyer_fiscal || null,
        annee_revenus: menage.annee_revenus || menage.menage?.annee_revenus || null,
        annee_imposition: menage.annee_imposition || menage.menage?.annee_imposition || null,
      };
    },
    handleMenageUpdate({ field, value }) {
  if (!this.menageData) {
    this.menageData = {};
  }
  this.menageData[field] = value;
},

    async clientupdate() {
      // Valider le formulaire avant de soumettre
      const isFormValid = await this.v$.$validate();
      console.log('=== VALIDATION FORM ===', {
        isFormValid,
        isProfessionel: this.isProfessionel,
        resultValid: this.resultValid,
        resultValidMobilePro: this.resultValidMobilePro,
        resultValidFixePro: this.resultValidFixePro,
        phoneValid: this.phoneValid,
        errors: this.v$.$errors
      });
      
      if (!isFormValid) {
        console.error('Formulaire invalide:', this.v$.$errors);
        return;
      }
      
      // Vérifier les validations de téléphone selon le type de client
      if (!this.isProfessionel) {
        // Pour les particuliers
        if (this.resultValid == false) {
          console.error('Téléphone mobile particulier invalide');
          return;
        }
        if (this.clientToConfig.tel_fixe && this.resultValidFixe == false) {
          console.error('Téléphone fixe particulier invalide');
          return;
        }
      } else {
        // Pour les professionnels
        const hasTelMobilePro = this.clientToConfig.tel_mobile_pro && this.clientToConfig.tel_mobile_pro.phone_number;
        const hasTelFixePro = this.clientToConfig.tel_fixe_pro && this.clientToConfig.tel_fixe_pro.phone_number;
        
        // Au moins un téléphone est requis pour les professionnels
        if (!hasTelMobilePro && !hasTelFixePro) {
          console.error('Au moins un téléphone (mobile ou fixe) est requis pour les professionnels');
          return;
        }
        
        // Si le téléphone mobile pro existe, il doit être valide
        if (hasTelMobilePro && this.resultValidMobilePro == false) {
          console.error('Téléphone mobile professionnel invalide');
          return;
        }
        
        // Si le téléphone fixe pro existe, il doit être valide
        if (hasTelFixePro && this.resultValidFixePro == false) {
          console.error('Téléphone fixe professionnel invalide');
          return;
        }
        
        // Vérifier aussi l'ancienne logique pour company_phone
        if (this.clientToConfig.company_phone && this.phoneValid == false) {
          console.error('Company phone invalide');
          return;
        }
      }
      this.erreurlist = {
        nom: null,
        prenom: null,
        email: null,
        rue: null,
        cp: null,
        ville: null,
        tel: null,
        type: null,
        entreprise: null,
        pays: null,
        SWIFT_BIC: null,
        // revenu_avis_imposition:null,
        IBAN: null,
        titulaire_compte: null,
        commentaire: null,
        forme_juridique:null,
        ape:null,
        naf:null,
        company: null,
        company_email: null,
        company_phone: null,
        zone: null,
        precarite: null,
        type_chauffage: null,
        type_logement: null,
        foyer_fiscal: null,
        annee_revenus: null,
        annee_imposition: null,
      };

      this.errorU = null;
      const data = {
        id: this.clientToConfig.id,
      };

      // Initialize basic data fields
      data.type = this.clientToConfig.type;
      data.nom = this.clientToConfig.nom;
      data.prenom = this.clientToConfig.prenom;
      data.email = this.clientToConfig.email;
      data.rue = this.clientToConfig.rue;
      data.complement_adresse = this.clientToConfig.complement_adresse || null;
      data.cp = this.clientToConfig.cp;
      data.ville = this.clientToConfig.ville;
      data.pays = this.clientToConfig.pays ? (this.clientToConfig.pays.iso_code || this.clientToConfig.pays.id) : null;

      // Champs pour particulier
      if (!this.isProfessionel) {
        if (this.clientToConfig.civilite_1) {
          data.civilite_1 = this.clientToConfig.civilite_1;
        }
        if (this.clientToConfig.civilite_2) {
          data.civilite_2 = this.clientToConfig.civilite_2;
        }
        if (this.clientToConfig.nom_2) {
          data.nom_2 = this.clientToConfig.nom_2;
        }
        if (this.clientToConfig.prenom_2) {
          data.prenom_2 = this.clientToConfig.prenom_2;
        }
        if (this.clientToConfig.email_2) {
          data.email_2 = this.clientToConfig.email_2;
        }
      }

      // Champs pour professionnel
      if (this.isProfessionel) {
        if (this.clientToConfig.raison_sociale) {
          data.raison_sociale = this.clientToConfig.raison_sociale;
        }
        if (this.clientToConfig.nom_commercial) {
          data.nom_commercial = this.clientToConfig.nom_commercial;
        }
        if (this.clientToConfig.siret) {
          data.siret = this.clientToConfig.siret;
        }
        if (this.clientToConfig.civilite) {
          data.civilite = this.clientToConfig.civilite;
        }
        // Utiliser nom et prenom pour définir signataire_nom et signataire_prenom
        if (this.clientToConfig.nom) {
          data.nom = this.clientToConfig.nom;
          data.signataire_nom = this.clientToConfig.nom;
        }
        if (this.clientToConfig.prenom) {
          data.prenom = this.clientToConfig.prenom;
          data.signataire_prenom = this.clientToConfig.prenom;
        }
        if (this.clientToConfig.ape_naf) {
          data.ape_naf = this.clientToConfig.ape_naf;
        }
        
        // Company is the same as nom and prenom (always required for professionnel)
        if (this.clientToConfig.nom && this.clientToConfig.prenom) {
          data.company = `${this.clientToConfig.nom} ${this.clientToConfig.prenom}`.trim();
        } else if (this.clientToConfig.nom) {
          data.company = this.clientToConfig.nom;
        } else if (this.clientToConfig.prenom) {
          data.company = this.clientToConfig.prenom;
        } else {
          // Fallback: use raison_sociale or nom_commercial or existing company if available
          data.company = this.clientToConfig.raison_sociale || this.clientToConfig.nom_commercial || this.clientToConfig.company || "";
        }
      }

      // Format numero tel mobile pour particulier
      const telMobileParticulier = this.clientToConfig.tel_mobile || (this.clientToConfig.phone && {
        phone_number: this.clientToConfig.phone.phone_number || this.clientToConfig.tel,
        phone_iso_code: this.clientToConfig.phone.iso_code || this.clientToConfig.phone.country_id?.iso_code || 'FR'
      });
      
      if (!this.isProfessionel && telMobileParticulier && telMobileParticulier.phone_number) {
        var num = telMobileParticulier.phone_number.indexOf(" ");
        if (num !== -1) {
          data.phone_number = telMobileParticulier.phone_number
            .slice(num + 1)
            .split(" ")
            .join("");
        } else {
          data.phone_number = telMobileParticulier.phone_number
            .split(" ")
            .join("");
        }
        data.tel = data.phone_number;
        data.phone_iso_code = telMobileParticulier.phone_iso_code;
      }
      
      // Format numero tel fixe pour particulier
      if (!this.isProfessionel && this.clientToConfig.tel_fixe && this.clientToConfig.tel_fixe.phone_number) {
        var numFixe = this.clientToConfig.tel_fixe.phone_number.indexOf(" ");
        if (numFixe !== -1) {
          data.tel_fixe = this.clientToConfig.tel_fixe.phone_number
            .slice(numFixe + 1)
            .split(" ")
            .join("");
        } else {
          data.tel_fixe = this.clientToConfig.tel_fixe.phone_number
            .split(" ")
            .join("");
        }
        data.tel_fixe_phone_number = data.tel_fixe;
        data.tel_fixe_phone_iso_code = this.clientToConfig.tel_fixe.phone_iso_code;
      }
      
      // Format numero tel mobile pour professionnel (tel = tel_mobile_pro)
      const telMobilePro = this.clientToConfig.tel_mobile_pro || (this.clientToConfig.phone && {
        phone_number: this.clientToConfig.phone.phone_number || this.clientToConfig.tel,
        phone_iso_code: this.clientToConfig.phone.iso_code || this.clientToConfig.phone.country_id?.iso_code || 'FR'
      });
      
      if (this.isProfessionel && telMobilePro && telMobilePro.phone_number) {
        var numPro = telMobilePro.phone_number.indexOf(" ");
        if (numPro !== -1) {
          data.phone_number = telMobilePro.phone_number
            .slice(numPro + 1)
            .split(" ")
            .join("");
        } else {
          data.phone_number = telMobilePro.phone_number
            .split(" ")
            .join("");
        }
        data.tel = data.phone_number;
        data.phone_iso_code = telMobilePro.phone_iso_code;
      }

      // Format numero tel company pour professionnel (company_tel = tel_fixe_pro ou company_phone)
      const telFixePro = this.clientToConfig.tel_fixe_pro || this.clientToConfig.company_phone;
      
      if (this.isProfessionel && telFixePro && telFixePro.phone_number) {
        var numFixePro = telFixePro.phone_number.indexOf(" ");
        if (numFixePro !== -1) {
          data.company_tel = telFixePro.phone_number
            .slice(numFixePro + 1)
            .split(" ")
            .join("");
        } else {
          data.company_tel = telFixePro.phone_number
            .split(" ")
            .join("");
        }

        data.company_phone_number = data.company_tel;
        data.company_phone_iso_code = telFixePro.phone_iso_code || telFixePro.iso_code;
      }

      // Définir l'entreprise_id selon le type d'utilisateur
      // D'abord, essayer de garder l'entreprise_id existant du client
      if (this.clientToConfig.entreprise_id) {
        data.entreprise_id = this.clientToConfig.entreprise_id;
      } else if (this.clientToConfig.entreprise && this.clientToConfig.entreprise.id) {
        data.entreprise_id = this.clientToConfig.entreprise.id;
      }
      
      // Ensuite, selon le type d'utilisateur, permettre la modification
      if (this.isCommercialBatigo) {
        data.entreprise_id = this.$route.query.entreprise || data.entreprise_id;
      } else if (this.isSuperAdmin) {
        // Super-admin peut changer l'entreprise
        if (this.clientToConfig.entreprise && this.clientToConfig.entreprise.id) {
          data.entreprise_id = this.clientToConfig.entreprise.id;
        } else if (!data.entreprise_id && this.getOnlineUser.entreprise && this.getOnlineUser.entreprise.id) {
          data.entreprise_id = this.getOnlineUser.entreprise.id;
        }
      } else {
        // Pour les autres types d'utilisateurs, utiliser l'entreprise de l'utilisateur connecté
        // Mais seulement si aucune entreprise n'est déjà définie
        if (!data.entreprise_id && this.getOnlineUser.entreprise && this.getOnlineUser.entreprise.id) {
          data.entreprise_id = this.getOnlineUser.entreprise.id;
        }
      }
      
      // Log pour débogage
      console.log('=== ENTREPRISE_ID ===', {
        isSuperAdmin: this.isSuperAdmin,
        isCommercialBatigo: this.isCommercialBatigo,
        isentrepriseAdmin: this.isentrepriseAdmin,
        entreprise_id: data.entreprise_id,
        clientEntrepriseId: this.clientToConfig.entreprise_id,
        clientEntreprise: this.clientToConfig.entreprise,
        userEntreprise: this.getOnlineUser.entreprise
      });
      if (this.clientToConfig.zone) {
        data.zone = this.clientToConfig.zone;
      }
      if (this.clientToConfig.precarite) {
        data.precarite = this.clientToConfig.precarite;
      }
      if (this.clientToConfig.type_occupation) {
        data.type_occupation = this.clientToConfig.type_occupation;
      }

      if (this.clientToConfig.titulaire_compte) {
        data.titulaire_compte = this.clientToConfig.titulaire_compte;
      }
      if (this.clientToConfig.commentaire) {
        data.commentaire = this.clientToConfig.commentaire;
      }
      if (this.clientToConfig.SWIFT_BIC) {
        // Remove spaces and convert to uppercase before sending to backend
        data.SWIFT_BIC = this.clientToConfig.SWIFT_BIC.replace(/\s+/g, '').toUpperCase();
      }

      if (this.clientToConfig.forme_juridique) {
        data.forme_juridique = this.clientToConfig.forme_juridique;
      }
      if (this.clientToConfig.ape) {
        data.ape = this.clientToConfig.ape;
      }
      if (this.clientToConfig.naf) {
        data.naf = this.clientToConfig.naf;
      }

      if (this.clientToConfig.IBAN) {
        // Remove spaces from IBAN before sending to backend
        data.IBAN = this.clientToConfig.IBAN.replace(/\s+/g, '').toUpperCase();
      }
      
      // Company email for professionnel (from email or company_email)
      // Company email doit être le même que email pour professionnel
      if (this.isProfessionel) {
        if (this.clientToConfig.email) {
          data.company_email = this.clientToConfig.email;
          data.email = this.clientToConfig.email; // Email est le même que email
        } else if (this.clientToConfig.company_email) {
          data.company_email = this.clientToConfig.company_email;
          data.email = this.clientToConfig.company_email; // Email est le même que company_email
        }
      } else if (this.clientToConfig.company_email) {
        data.company_email = this.clientToConfig.company_email;
      }
      
      // Poste (from fonction or poste) for professionnel and particulier
      if (this.clientToConfig.fonction) {
        data.poste = this.clientToConfig.fonction;
      } else if (this.clientToConfig.poste) {
        data.poste = this.clientToConfig.poste;
      }

      // Log des données avant l'envoi pour débogage
      console.log('=== DONNÉES À ENVOYER (PROFESSIONNEL) ===', {
        isProfessionel: this.isProfessionel,
        data: JSON.stringify(data, null, 2),
        clientToConfig: {
          type: this.clientToConfig.type,
          nom: this.clientToConfig.nom,
          prenom: this.clientToConfig.prenom,
          email: this.clientToConfig.email,
          raison_sociale: this.clientToConfig.raison_sociale,
          siret: this.clientToConfig.siret,
          tel_mobile_pro: this.clientToConfig.tel_mobile_pro,
          tel_fixe_pro: this.clientToConfig.tel_fixe_pro,
          company_phone: this.clientToConfig.company_phone,
          entreprise: this.clientToConfig.entreprise
        }
      });

      await this.edit_client({
        refObject: this.clientToConfigRef,
        data: data,
      })
        .then(() => {
          console.log('=== CLIENT MODIFIÉ AVEC SUCCÈS ===');
          this.setup();
          this.errorU = null;
        
        //   this.hideModal("ModelConfigclient");
        //   this.hideModal("Modelclient");
        })
        .catch((err) => {
          console.error('=== ERREUR LORS DE LA MODIFICATION ===', err);
          if (this.isObject(err)) {
            for (const [key, value] of Object.entries(err)) {
              if (!this.erreurlist[key]) {
                this.erreurlist[key] = value;
              }
            }
          } else {
            this.errorU = err;
          }
        });
        // Store or update menage only for particulier (if data is available)
        const hasMenageData = (this.menageData && (this.menageData.revenu || this.menageData.personnes || this.menageData.commune || this.menageData.foyer_fiscal || this.menageData.annee_revenus || this.menageData.annee_imposition));
        if (!this.isProfessionel && hasMenageData) {
          if(this.clientToConfig.menage){
            const menage={
              id: this.clientToConfig.menage.id,
              client_id: this.clientToConfig.id,
              revenu: (this.menageData && this.menageData.revenu) || null,
              personnes: (this.menageData && this.menageData.personnes) || null,
              commune: (this.menageData && this.menageData.commune) || null,
              foyer_fiscal: (this.menageData && this.menageData.foyer_fiscal) || null,
              annee_revenus: (this.menageData && this.menageData.annee_revenus) || null,
              annee_imposition: (this.menageData && this.menageData.annee_imposition) || null,
            }
            await this.editMenage(menage).catch(err => {
              console.warn("Erreur lors de la mise à jour du ménage:", err);
              // Continue même si le ménage n'a pas pu être mis à jour
            });
          } else {
            const menage={
              client_id: this.clientToConfig.id,
              revenu: (this.menageData && this.menageData.revenu) || null,
              personnes: (this.menageData && this.menageData.personnes) || null,
              commune: (this.menageData && this.menageData.commune) || null,
              foyer_fiscal: (this.menageData && this.menageData.foyer_fiscal) || null,
              annee_revenus: (this.menageData && this.menageData.annee_revenus) || null,
              annee_imposition: (this.menageData && this.menageData.annee_imposition) || null,
            }
            await this.storeMenage(menage).catch(err => {
              console.warn("Erreur lors de la création du ménage:", err);
              // Continue même si le ménage n'a pas pu être créé
            });
          }
        }
      
        this.$router.push("/client");
    },

    resetModal() {
     this.errorS = null;
      this.errorD = null;
      this.errorU = null;

      this.$router.push("/client");
    },

    validateState(name) {
      const fieldValidation = this.v$.clientToConfig[name];
      if (fieldValidation) {
        const { $dirty, $error } = fieldValidation;
        return $dirty ? !$error : null;
      }
      return null;
    },
    updateSignataireNom(event) {
      const value = event.target ? event.target.value : event;
      this.clientToConfig.signataire_nom = value;
    },
    updateSignatairePrenom(event) {
      const value = event.target ? event.target.value : event;
      this.clientToConfig.signataire_prenom = value;
    },
 
    formatNumber(event) {
      if (!this.isProfessionel) {
        if (!this.clientToConfig.tel_mobile) {
          this.clientToConfig.tel_mobile = {};
        }
        this.clientToConfig.tel_mobile = {
          phone_number: event.number,
          phone_iso_code: event.country.iso2,
        };
      } else {
        this.clientToConfig.phone = {
          phone_number: event.number,
          phone_iso_code: event.country.iso2,
        };
      }
      this.resultValid = event.isValid;
    },

    formatNumberE(event) {
      this.clientToConfig.company_phone = {
        phone_number: event.number,
        iso_code: event.country.iso2,
      };
      this.phoneValid = event.isValid;
      this.erreurlist.company_phone = null;
    },

    formatNumberFixe(event) {
      if (!this.isProfessionel) {
        if (!this.clientToConfig.tel_fixe) {
          this.clientToConfig.tel_fixe = {};
        }
        this.clientToConfig.tel_fixe.phone_number = event.number;
        this.clientToConfig.tel_fixe.phone_iso_code = event.country.iso2;
      }
      this.resultValidFixe = event.isValid;
    },

    formatMobileNumberPro(event) {
      if (this.isProfessionel) {
        if (!this.clientToConfig.tel_mobile_pro) {
          this.clientToConfig.tel_mobile_pro = {};
        }
        this.clientToConfig.tel_mobile_pro.phone_number = event.number;
        this.clientToConfig.tel_mobile_pro.phone_iso_code = event.country.iso2;
        this.resultValidMobilePro = event.isValid;
      }
    },

    formatFixedNumberPro(event) {
      if (this.isProfessionel) {
        if (!this.clientToConfig.tel_fixe_pro) {
          this.clientToConfig.tel_fixe_pro = {};
        }
        this.clientToConfig.tel_fixe_pro.phone_number = event.number;
        this.clientToConfig.tel_fixe_pro.phone_iso_code = event.country.iso2;
        this.resultValidFixePro = event.isValid;
      }
    },
    isObject(obj) {
      return Object.prototype.toString.call(obj) === "[object Object]";
    },

    selectentreprise(query) {
      this.search = "";
      if (query) {
        this.all_clients({
          page: this.page,
          per_page: this.perPage,
          entreprise_id: query.id,
        });

        this.current_entreprise = query;
      } else {
        this.current_entreprise = {
          lib: null,
        };
        this.all_clients({
          page: this.page,
          per_page: this.perPage,
        });
      }

      this.hideModal("entrepriseModal");
    },

    setup(refresh = false) {
      if (refresh) {
        this.page = 1;
        this.search = null;
      }
      this.currenttype = this.filtre_type;
      if (this.$route.query.entreprise) {
        this.current_entreprise.id = this.$route.query.entreprise;
        this.entreprise({ id: this.$route.query.entreprise });
        this.all_clients({
          page: this.page,
          per_page: this.perPage,
          entreprise_id: this.$route.query.entreprise,
          type: this.currenttype,
        });
      } else {
        if (this.isSuperAdmin) {
          this.all_clients({
            page: this.page,
            per_page: this.perPage,
            entreprise_id: this.current_entreprise.id,
            type: this.currenttype,
          });
        } else {
          this.all_clients({
            page: this.page,
            per_page: this.perPage,
            entreprise_id: this.getOnlineUser.entreprise.id,
            type: this.currenttype,
          });
        }
      }
    },
  },

    }
    </script>